/**
 * Scrolls the window to an element's top over a duration, eased as jQuery's
 * default "swing" animation.
 * @param element - The element to bring to the top of the window
 * @param duration - The scroll's length in milliseconds
 */
const scrollToSection = (element: HTMLElement | null, duration: number) => {
  if (!element) return;

  const start = window.pageYOffset;
  const target = element.getBoundingClientRect().top + start;
  const began = performance.now();

  const step = (now: number) => {
    const progress = Math.min((now - began) / duration, 1);
    const eased = 0.5 - Math.cos(progress * Math.PI) / 2;

    window.scrollTo(0, start + (target - start) * eased);

    if (progress < 1) window.requestAnimationFrame(step);
  };

  window.requestAnimationFrame(step);
};

export default scrollToSection;
